import React, { JSX } from 'react';
import { ColorProps, SpaceProps, TypographyProps } from 'styled-system';
import { StyledTitle, StyledTitleBorder } from './style';
import { ComposeType, StyledDiv } from '../../../Theme/CommonStyled';

type TitleType = ColorProps &
  SpaceProps &
  TypographyProps & {
    title: JSX.Element | string;
  };
const Title: React.FC<TitleType> = ({ title, ...rest }) => {
  return (
    <StyledTitle {...rest}>
      <StyledTitleBorder />
      <StyledDiv display="flex" alignItems="center" mx={7}>
        {title}
      </StyledDiv>
      <StyledTitleBorder />
    </StyledTitle>
  );
};

export default Title;
